<template>
    <div class="testimonials">
        <div class="centered-heading">
            <h2 class="intro">
                We are recommended by hundreds of companies and contractors
            </h2>
        </div>
        <div class="content">
            <div class="image-items">
                <div class="avatar" @mouseover="mouseOver(testimonial)" @mouseleave="mouseLeave" v-for="testimonial in testimonialsList">
                    <img :src="testimonial.file.url" :alt="testimonial.file.name"/>
                </div>
            </div>
            <div class="on-display" @mouseover="mouseIn = true" @mouseleave="mouseIn = false">
                <div class="avatar">
                    <img :src="onDisplay.file.url" :alt="onDisplay.name"/>
                </div>
                <div class="name" v-text="onDisplay.name"></div>
                <label class="company" v-text="onDisplay.company"></label>
                <div class="message" v-html="strlimit(onDisplay.message, 250)"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

        props:{
            testimonials:{
                type: Array,
                required: true
            }
        },

        data() {
            return {
                mouseIn : false,
                onDisplay: this.testimonials[0],
            }
        },

        mounted() {
            setInterval(() => {
                if(!this.mouseIn) {
                    this.onDisplay = _.sample(this.testimonialsList);
                }
            }, 3000)
        },

        methods: {
            mouseLeave(){
                this.mouseIn = false;
            },

            mouseOver(testimonial) {
                this.mouseIn = true;
                this.onDisplay = testimonial;
            }
        },

        computed: {
            testimonialsList() {
                return this.testimonials.map(item => {
                    if (item.files.length) {
                        item['file'] = item.files[0]
                    }else{
                        item['file'] = {url: '', name: ''}
                    }
                    return item;
                })
            }
        }
    }
</script>